export const m = {
  EnterID: "انقر لإدخال Tada ID",
  "select-specifications": "انقر لاختيار مواصفات الدفع",
  "check-account": "مراجعة حساب الدفع",
  whatID: "ما هو Tada ID",
  getID: "ادخل Tada ID",
  maskgetID: "ادخل Tada ID",
  "toastTips-format-error": " إدخال غير صحيح",
  "toastTips-no-exist": "IDغير موجود",
  toastTipsPlease: "يرجى التحقق من حساب الدفع أولاً",
  "common-problem": "الأسئلة الشائعة",
  "transaction-succeeded": " نجحت هذه الصفقة",
  "transaction-failed": "فشلت هذه الصفقة",
  "transaction-cancel": "إلغاء الصفقة",
  "whether-account": "1. كيف أتحقق مما إذا كان قد تم مبلغ الدفع بعد الدفع؟",
  "answer-whether-account":
    "بعد الدفع، يمكنك العودة إلى [حسابي] - [محفطة] للتطبيق لعرض الالماس",
  "no-account": "ماذا أفعل لو لم يصل مبلغ الحساب بعد الدفع؟2.",
  "answer-no-account":
    "يرجى إرسال أسئلتك في تطبيق [الأخبار] - [الأخبار الرسمية] - [التعليقات والمساعدة]، وتوفير المعلومات التالية، سوف تساعدك خدمة العملاء لدينا.",
  "recharge-money": "1. مبلغ الدفع وحسابك",
  "recharge-time": "2. وقت وتاريخ الدفع",
  "recharge-shot": "3. لقطة شاشة للدفع الناجح.",
  "recharge-wrong": "3.ماذا أفعل إذا قمت بدفع لحساب خاطئ ودفع المبلغ الخاطئ؟",
  "answer-recharge-wrong":
    "قبل إدخال كلمة مرور للدفع، يجب تأكيد هوية حساب الدفع ومبلغ بعناية قبل إجراء عملية الشراء. لا يمكن استرداد مبلغ الدفع الخاطئ. بالنسبة لحساب الدفع الخاطئ، يمكنك محاولة الاتصال بالمستخدم الذي دفعت بالفعل والتفاوض معه سواء كان على استعداد لتعويض دفعك.",
  refund: "4.رد المال",
  "answer-refund": "آسف! لا يدعم Tada حاليًا أي شكل من رد الأموال.",
  "buy-enter-link":
    'يمكن شراء الماس من خلال الرابط <a class="web-link"  href="https://pay.tadachat.live/" >https://pay.tadachat.live</a> انسخ الرابط في متصفح الجوال لفتحه، وأدخل صفحة الشراء، وبعد التحقق من الحساب، حدد المواصفات المقابلة واستخدم طريقة الدفع المناسبة للدفع ~ هناك كثير من الخصومات!',
  "buy-notice-a":
    "ملاحظة: <a>pay.tadachat.live</a>  هو الموقع الرسمي الوحيد لشراء الماس لـ Tada",
  replace: "استبدل",
  sureBtn: "موافق",
  "pay-style": "اختر طريقة الدفع ",
  goBack: "رجوع إلى الصفحة الرئيسية",
  toastTips: "ادخل Tada ID",
  rechargeFAQ_title: "الأسئلة الشائعة",
  PayStatusSuccess_title: " نجحت هذه الصفقة",
  PayStatusFail_title: "فشلت هذه الصفقة",
  PayStatusCancel_title: "إلغاء الصفقة",
  Diamonds_title: "موقع الدفع الرسمي Tada للألماس   ",
  "buy-notice":
    "ملاحظة pay.Tadachat.live هو الموقع الرسمي الوحيد لشراء الماس من Tada. لاستفسارات خدمة العملاء ، يرجى الانتقال إلى [رسالة] - [أخبار رسمية] - [ملاحظات ومساعدة]",
  RechargeHelp_title: "مساعدة إعادة الشحن",
  openAPP: "افتح تطبيق Tada",
  "buy-diamonds-tit": "شراء خدمات الماس",
  description:
    "إن Tada موقع رسمي وحيد لدفع الماس ، Tada هو برنامج اجتماعي دولي ، ويستخدمه المستخدمون في أكثر من 150 دولة ومنطقة حول العالم ",
  keywords:
    "Tada لدفع،Tada لدفع ألماس،Tada لدفع الرسمي ،موقع Tada للدفع الرسميللدفع الرسمي",
  trueText: "موافق",
  falseText: "إلغاء",
  alertShowTxt1: "هل أنت متأكد من استخدام",
  alertShowTxt3: " لإعادة شحن",
  alertShowTxt5: " الماس؟",
  payforType: "طريقة الشحن",
  //  إعادة شحن Tada السريعإعادة شحن Tada السريع

  EnterIDTip: "إعادة شحن Tada السريع",

  scanLogin: "لخصوصية وأمان الحساب ، يرجى مسح الكود لتسجيل الدخول",
  scanTip:
    '"نصيحة: انقرعلي المركز الشخصي / منشورة Tada وعلي مسح الكود في الزاوية العليا,تسجيل الدخول ، ودعم أيضا تسجيل الدخول عن طريق لقطة الشاشة بتحديد كود الاستجابة السريعة"',
  //   تسجيل الدخول ، ودعم أيضا تسجيل الدخول عن طريق لقطة الشاشة بتحديد كود الاستجابة السريعة"
  scanVersion: "الرجاء ترقية Tada إلى النسخة %s ومسح الكود لتسجيل الدخول",
  delAccount: "حذف الحساب",
  logout: "الخروج من تسجيل الدخول",
  submit: "تقديم",
  email_place_holder: "أدخل صندوق البريد الخاص بك",
  contact_email: "تتصل بالبريد الاكتروني",
  provide_email: "يرجى تقديم عنوان بريدك الإلكتروني لتستقبل إعلان الدفع",
  email_address: "عنوان البريد الاكتروني",
};



// WEBPACK FOOTER //
// ./src/lang/ar.js